module.exports = __webpack_public_path__ + "static/media/icon.76711e7f.svg";